import { Component, OnInit } from '@angular/core';

const NAVLINKS = [
  {title: 'Gange øvelser', link:'/menu-multiply', content:'Forskellige øvelser til at blive bedre til at gange.'},
  {title: 'Regn med Brøker', link:'/menu-fractions', content:'Blive bedre til at regne med brøker og lær de forskellige regneregler for brøker.'},
  {title: 'Procentregning', link:'/menu-procentage', content:'Få styr på at regne med procenter.'}
];


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})

export class MenuComponent implements OnInit {

  navLinks = NAVLINKS;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/menu/menu.component.ts